function map_range(zeValue, low1, high1, low2, high2) {
    return low2 + (high2 - low2) * (zeValue - low1) / (high1 - low1);
}

export const formatText = (value, zeMin, zeMax) => {
    const min = Number.isFinite(zeMin) ? zeMin : 0;
    const max = Number.isFinite(zeMax) ? zeMax : 100;

    // éviter division par 0
    if (min === max) {
        return min;
    }

    return Math.trunc(map_range(value, 0, 100, min, max));
};